export default {"frames": [

{
	"filename": "loader_1.png",
	"frame": {"x":1,"y":1,"w":262,"h":324},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":60,"y":29,"w":262,"h":324},
	"sourceSize": {"w":384,"h":384}
},
{
	"filename": "loader_2.png",
	"frame": {"x":265,"y":1,"w":254,"h":319},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":64,"y":30,"w":254,"h":319},
	"sourceSize": {"w":384,"h":384}
},
{
	"filename": "loader_3.png",
	"frame": {"x":521,"y":1,"w":245,"h":309},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":72,"y":32,"w":245,"h":309},
	"sourceSize": {"w":384,"h":384}
},
{
	"filename": "loader_4.png",
	"frame": {"x":768,"y":1,"w":252,"h":301},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":78,"y":35,"w":252,"h":301},
	"sourceSize": {"w":384,"h":384}
},
{
	"filename": "loader_5.png",
	"frame": {"x":1,"y":327,"w":239,"h":309},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":74,"y":31,"w":239,"h":309},
	"sourceSize": {"w":384,"h":384}
},
{
	"filename": "loader_6.png",
	"frame": {"x":242,"y":327,"w":249,"h":308},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":70,"y":35,"w":249,"h":308},
	"sourceSize": {"w":384,"h":384}
},
{
	"filename": "loader_7.png",
	"frame": {"x":493,"y":327,"w":257,"h":312},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":63,"y":34,"w":257,"h":312},
	"sourceSize": {"w":384,"h":384}
},
{
	"filename": "loader_8.png",
	"frame": {"x":752,"y":327,"w":249,"h":308},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":70,"y":38,"w":249,"h":308},
	"sourceSize": {"w":384,"h":384}
}],
"meta": {
	"app": "https://www.codeandweb.com/texturepacker",
	"version": "1.0",
	"image": "loader.png",
	"format": "RGBA8888",
	"size": {"w":1024,"h":1024},
	"scale": "1",
	"smartupdate": "$TexturePacker:SmartUpdate:d534ab51bd9c63be762a698763879c3e:c959a867ef1956a25660c1d23fe2a951:f738fe997bb2212a06178648a8058842$"
}
}
